import React from "react";
import {
  Document,
  Image,
  Font,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";

import RobotoBlack from "fonts/Roboto-Black.ttf";

Font.register({
  family: "Roboto",
  fonts: [{ src: RobotoBlack, fontWeight: 900 }],
});

const StickerEanCode = ({ data }) => (
  <Document>
    <Page size={{ width: 305, height: 60 }} style={styles.page}>
      <View style={styles.wrapper} wrap={true}>
        {data?.length > 0 &&
          data.map(({ sku, quantity, barcode }, index) => {
            return (
              <React.Fragment key={index}>
                <View style={styles.box}>
                  <View style={styles.text_wrapper}>
                    <Text style={styles.text_normal}>{sku}</Text>
                    <Text style={styles.text_normal}>{quantity} szt.</Text>
                  </View>
                </View>
                {Array(Number(quantity))
                  .fill(null)
                  .map((_, index) => (
                    <View style={styles.box} key={index}>
                      <Image
                        src={barcode}
                        style={{
                          width: 90,
                          height: 50,
                        }}
                      />
                    </View>
                  ))}
              </React.Fragment>
            );
          })}
      </View>
    </Page>
  </Document>
);

export default StickerEanCode;

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    paddingTop: 5,
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
  },
  box: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: 100,
  },

  text_wrapper: {
    paddingBottom: 5,
    paddingLeft: 12,
    width: '100%'
  },
  text_normal: {
    fontFamily: "Roboto",
    fontSize: 7,
    fontWeight: 900,
    marginBottom: 3,
  },
});
